var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-xs-center mt-5 pt-5",attrs:{"justify-center":""}},[_c('v-progress-circular',{attrs:{"size":100,"width":15,"color":"purple","valvue":"Loading","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }